/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable */
import React, { useContext, useState, useEffect } from 'react';
import {
  CustomerRecordStateContext,
  CustomerRecordDispatchStateContext,
} from '../../context/CustomerRecordCheck/CustomerRecordProvider';
import {
  Grid,
  Typography,
  RACTable,
  RACCheckBox,
  RACButton,
  Card,
  CardContent,
  RACTableCell,
  RACTableRow,
  Box,
  RACDateTimeLabel,
} from '@rentacenter/racstrap';
import { globalStyles } from '../../jsStyles/globalStyles';
import {
  columnKeyMap,
  CRCGridHeader,
  INITIAL_OFFSET,
  PAST_DUE_LIST_API_LIMIT,
  RECORD_CHECK_LIST_API_LIMIT,
  RECORD_HEIGHT,
} from '../../constants/constants';
import CustomerQueue from './CRCSelectedCustomer';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Loader } from '../../common/ApiStateWrapper/ApiStateWrapper';
import {
  abbrev,
  formatDateString,
  getSelectedStore,
  maskData,
} from '../../utils/utils';
import { postSearch } from '../../api/user';
import { ReactComponent as SortDownIcon } from '../../assets/img/sort-down-icon.svg';
import { ReactComponent as SortUpIcon } from '../../assets/img/sort-up-icon.svg';
import { sortData } from '../../utils/getCustomerInformation';
import { useStoreDetails } from '../../context/Store/StoreProvider';

const CustomerSearchResultGrid = () => {
  const classes = globalStyles();
  const {
    searchResults = [],
    queuedCustomers,
    hasMore,
    searchLoading,
    customerBasicInformation,
    offset,
    searchPerformed,
    selectedCustomerQueue,
  } = useContext(CustomerRecordStateContext);
  const {
    setSearchResults,
    addToQueue,
    setSearchListLoading,
    setOffsetValue,
    setMainSearch,
  } = useContext(CustomerRecordDispatchStateContext);

  const { DateTimeLocalization, store } = useStoreDetails();
  const [sortedColumn, setSortedColumn] = useState<string | null>(null);
  const [sortOrder, setSortOrder] = useState<'asc' | 'desc'>('asc');
  const [selectedCount, setSelectedCount] = useState<number>(INITIAL_OFFSET);
  const [selectAll, setSelectAll] = useState(false);
  const [showQueueMessage, setShowQueueMessage] = useState(false);
  const [showMain, setShowMain] = useState(false);
  const [containerHeight, setContainerHeight] = useState(225);

  useEffect(() => {
    const selectedCount = searchResults.filter((c) => c.checked === 1).length;
    setSelectedCount(selectedCount);

    const allSelected =
      searchResults.length > 0 && searchResults.every((c) => c.checked === 1);
    setSelectAll(allSelected);

    const visibleCount = searchResults.length;

    setContainerHeight(visibleCount < 4 ? RECORD_HEIGHT * 3 : 300);
  }, [searchResults]);

  const handleShowMessage = () => {
    setShowQueueMessage(true);

    setTimeout(() => {
      setShowQueueMessage(false);
    }, 5000);
  };

  const handleSort = (column: string) => {
    const key = columnKeyMap[column];
    const order =
      sortedColumn === column && sortOrder === 'asc' ? 'desc' : 'asc';
    const sorted = sortData(searchResults, key, order);
    setSearchResults(sorted);
    setSortedColumn(column);
    setSortOrder(order);
  };

  const fetchNextPage = async () => {
    try {
      if (!searchResults || searchResults.length < 1) return;
      const newOffset = offset + PAST_DUE_LIST_API_LIMIT;
      setOffsetValue(newOffset);
      const limit = RECORD_CHECK_LIST_API_LIMIT;
      setSearchListLoading(true);

      const {
        firstName,
        lastName,
        dateOfBirth,
        ssn1,
        ssn2,
        ssn3,
        phoneNumber,
        agreementNumber,
        state,
        addressLine1,
        addressLine2,
        zip,
        city,
      } = customerBasicInformation;

      const storeNumber = getSelectedStore();

      const payloadReq: Record<string, any> = {};

      const addIfExists = (key: string, value: any) => {
        if (value !== undefined && value !== null && value !== '') {
          payloadReq[key] = typeof value === 'string' ? value.trim() : value;
        }
      };

      addIfExists('firstName', firstName);
      addIfExists('lastName', lastName);
      addIfExists('dateOfBirth', dateOfBirth);
      addIfExists('agreementNumber', agreementNumber);
      addIfExists('addressLine1', addressLine1);
      addIfExists('addressLine2', addressLine2);
      addIfExists('zip', zip);
      addIfExists('city', city);

      if (state && state !== '0') {
        payloadReq.state = state;
      }

      if (ssn1 && ssn2 && ssn3) {
        payloadReq.ssn = `${ssn1}${ssn2}${ssn3}`;
      }

      if (phoneNumber) {
        const cleanedPhone = phoneNumber.replace(/\D/g, '');
        if (cleanedPhone.length === 10) {
          payloadReq.phoneNumber = cleanedPhone;
        }
      }

      if (queuedCustomers.length > 0) {
        payloadReq.excludeCustomerIds = queuedCustomers.map(
          (customer) => customer.customerId
        );
      }

      if (queuedCustomers.length > 0 || selectedCustomerQueue.length > 0) {
        const excludeIds = [
          ...queuedCustomers.map((c) => c.customerId),
          ...selectedCustomerQueue.map((c) => c.customerId),
        ];

        payloadReq.excludeCustomerIds = Array.from(new Set(excludeIds));
      }

      const payload = {
        ...payloadReq,
        limit,
        offset: newOffset,
        storeNumber,
      };
      console.log('payload', payload);

      const response = await postSearch(payload);
      const customers = response?.customerDetails ?? [];
      console.log('customers', response);
      setSearchResults(customers, true);
    } catch (error) {
      console.error('Search failed:', error);
    } finally {
      setSearchListLoading(false);
    }
  };

  const handleCheckboxChange = (e: any, index: number) => {
    const selected = e.target.checked;
    const updatedResults = [...searchResults];
    updatedResults[index] = {
      ...updatedResults[index],
      checked: selected ? 1 : 0,
    };
    setSearchResults(updatedResults);
  };

  const handleSelectAll = (e: any) => {
    const newSelectAll = e.target.checked;
    setSelectAll(newSelectAll);

    const updatedResults = searchResults.map((customer) => ({
      ...customer,
      checked: newSelectAll ? 1 : 0,
    }));

    setSearchResults(updatedResults);
  };

  const handleAddSelectedToQueue = () => {
    setShowMain(true);
    const selected = searchResults.filter((customer) => customer.checked === 1);
    const remaining = searchResults.filter(
      (customer) => customer.checked !== 1
    );

    addToQueue(selected, true);
    setSearchResults(remaining);
    handleShowMessage();
    setMainSearch(false);
  };

  const renderSearchTableHead = () => (
    <>
      <RACTableCell>
        <RACCheckBox
          label=""
          size="small"
          name="select_all"
          checked={selectAll}
          onChange={(e) => handleSelectAll(e)}
        />
      </RACTableCell>
      {CRCGridHeader.map((col, index) => (
        <RACTableCell className="racstrap-tablecell-BgColor" key={index}>
          {col === 'First Name' || col === 'Last Name' ? (
            <a
              onClick={() => handleSort(col)}
              style={{ cursor: 'pointer', marginLeft: 8 }}
            >
              {col}
              {sortedColumn === col && sortOrder === 'asc' ? (
                <SortDownIcon className="ms-1" />
              ) : (
                <SortUpIcon className="ms-1" />
              )}
            </a>
          ) : (
            col
          )}
        </RACTableCell>
      ))}
    </>
  );

  const renderSearchTableContent = (): JSX.Element => {
    if ((searchResults.length === 0 && !showMain) || searchPerformed) {
      return (
        <RACTableRow hover backgroundColor="white">
          <RACTableCell
            colSpan={CRCGridHeader.length + 1}
            style={{ textAlign: 'center', padding: '20px', fontWeight: 'bold' }}
          >
            No Records Found
          </RACTableCell>
        </RACTableRow>
      );
    }

    return (
      <>
        {searchResults.map((record, index) => (
          <RACTableRow key={index} backgroundColor="white">
            <RACTableCell>
              <RACCheckBox
                label=""
                size="small"
                name={`checkbox_${index}`}
                checked={record.checked === 1}
                onChange={(e) => handleCheckboxChange(e, index)}
              />
            </RACTableCell>
            <RACTableCell>{record?.lastName}</RACTableCell>
            <RACTableCell>{record?.firstName}</RACTableCell>
            <RACTableCell>{record?.city}</RACTableCell>
            <RACTableCell>{record?.state}</RACTableCell>
            <RACTableCell>{record?.zipcode}</RACTableCell>
            <RACTableCell>
              {maskData(record?.phoneNumber, { maskType: 'unmaskPH' })}
            </RACTableCell>
            <RACTableCell>{record?.daysPastDue}</RACTableCell>
            <RACTableCell>{record?.route}</RACTableCell>
            <RACTableCell> { DateTimeLocalization ?
              <RACDateTimeLabel
                value={formatDateString(
                  record?.dueDate || ''
                )}
                country={store?.countryAbb}
                displayType={'ShortDate'}
              />
              : formatDateString(record?.dueDate)}</RACTableCell>
            <RACTableCell>{abbrev(record?.commitment) || '-'}</RACTableCell>
            <RACTableCell>{record?.contactsTotal}</RACTableCell>
            <RACTableCell>{record?.contactsToday}</RACTableCell>
          </RACTableRow>
        ))}
      </>
    );
  };

  return (
    <>
      {(searchResults.length > 0 || showMain) && (
        <Grid
          container
          className={`${classes.mt2px} ${classes.width100p}`}
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item>
            {showQueueMessage && (
              <Box className={classes.toast}>
                Customer added to the queue successfully.
              </Box>
            )}
          </Grid>

          <Grid item className={`${classes.displayFlex} ${classes.alignments}`}>
            <Typography className={`${classes.mt2px} ${classes.testclr}`}>
              {selectedCount} Selected
            </Typography>
            <RACButton
              variant="contained"
              className={`${classes.floatRight} ${classes.ms2} ${classes.mt2} ${classes.ml}`}
              color="primary"
              disabled={selectedCount === 0}
              onClick={() => handleAddSelectedToQueue()}
            >
              Add Customer to Queue
            </RACButton>
          </Grid>
        </Grid>
      )}

      <Grid
        container
        className={`${classes.width100p} px-2 mb-2 ${classes.mt10px}`}
      >
        <Card className={`${classes.width100p} card`}>
          <CardContent className={classes.width100p}>
            <InfiniteScroll
              next={fetchNextPage}
              dataLength={searchResults?.length || 0}
              hasMore={hasMore}
              height={containerHeight}
              loader={
                searchLoading && searchResults?.length ? <Loader /> : null
              }
            >
              <Grid item md={12} className={classes.width100p}>
                <RACTable
                  renderTableHead={renderSearchTableHead}
                  renderTableContent={renderSearchTableContent}
                  stickyHeader
                />
              </Grid>
            </InfiniteScroll>
          </CardContent>
        </Card>
      </Grid>

      {queuedCustomers.length > 0 && (
        <Grid container className={`${classes.mt10px} ${classes.width100p}`}>
          <Typography
            className={`${classes.fontOpensansBold}  ${classes.fontSize16px} ${classes.p10}`}
          >
            Selected Customer List - Record Check Queue
          </Typography>
          <CustomerQueue />
        </Grid>
      )}
    </>
  );
};

export default CustomerSearchResultGrid;
